import { render, staticRenderFns } from "./HowItWorkProcess.vue?vue&type=template&id=35abfb55&scoped=true"
import script from "./HowItWorkProcess.vue?vue&type=script&lang=ts"
export * from "./HowItWorkProcess.vue?vue&type=script&lang=ts"
import style0 from "./HowItWorkProcess.vue?vue&type=style&index=0&id=35abfb55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35abfb55",
  null
  
)

export default component.exports